import { h } from 'preact';
export const CornerUpRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "15 14 20 9 15 4" }),
        h("path", { d: "M4 20v-7a4 4 0 0 1 4-4h12" })));
};
//# sourceMappingURL=corner-up-right.js.map